import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_95gwwb5hnm: FaireBrandEntity = {
  token: "b_95gwwb5hnm",
  type: "brand",
  name: "Little Nehemiah",
  avatarUrl:
    "https://cdn.faire.com/fastly/da3047fae57d403e0bf734301b0ec8227d9045a092004e9cfc20ddf5f8b45e14.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fe571bb0bda8f81f3980a2fbea023c25e8a4c7141212745a269315d93d444e45.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/da3047fae57d403e0bf734301b0ec8227d9045a092004e9cfc20ddf5f8b45e14.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fe571bb0bda8f81f3980a2fbea023c25e8a4c7141212745a269315d93d444e45.jpeg",
  location: "San Antonio, TX, USA",
  minimumOrderDollars: 139,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    'Little Nehemiah was born on the frontlines of a global mission. In 2017, our team of Christian educators provided truth-based curriculums to families in restricted regions. When harsh bans confiscated our textbooks, we discovered a "blind spot" in censorship: building block toys. We broke the truth down and snuck it in, piece by piece, hidden inside premium toy boxes.\n\nAs we designed these sets to bypass physical blockades, we realized parents in the free world fight a different battle: the constant noise of screens and a secular culture competing for our children\'s hearts.\n\nThat’s why we turn abstract biblical teachings into premium brick sets kids can physically build. We want passing down the faith to be a joy-filled, screen-free experience.\n\nEvery purchase equips parents with a powerful tool to connect with their kids, while funding our ongoing work to reach children living under intense pressure. Partner with us to help the next generation Build, Believe, and Become.',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.700Z",
    importedBy: "entity-db-cli",
  },
};
